/* eslint-disable prettier/prettier */
import { CollapsibleSection } from '../CollapsibleSection';
import { KeyValuePair } from '../../ui/KeyValuePair';
import { getFieldValue } from '../../../utils/getFieldValue';
import { emojiIconMap } from '../../../utils/emojiIconMap';
import { TreatyEntityType } from '../../../types/TreatyEntityType';

export const BrokersSection = ({
  brokers,
  refreshTreatyData,
}: {
  brokers: any[];
  refreshTreatyData?: () => void;
}) => {
  const isMultiple = brokers.length > 1;

  return (
    <CollapsibleSection title={isMultiple ? 'Brokers' : 'Broker'} icon={emojiIconMap['Broker']}>
      {isMultiple
        ? brokers.map((broker, index) => {
            const { value, ai_result } = getFieldValue(broker.brokerName);

            return (
              <CollapsibleSection key={broker.id || index} title={`Broker ${index + 1}`}>
                <KeyValuePair
                  label="Broker Name"
                  value={value}
                  aiValue={ai_result}
                  editable={true}
                  entityId={broker.id}
                  entityType={TreatyEntityType.BROKER}
                  fieldKey="brokerName"
                  refreshTreatyData={refreshTreatyData}
                />
              </CollapsibleSection>
            );
          })
        : (() => {
            const { value, ai_result } = getFieldValue(brokers[0]?.brokerName);

            return (
              <KeyValuePair
                label="Broker Name"
                value={value}
                aiValue={ai_result}
                editable={true}
                entityId={brokers[0]?.id}
                entityType={TreatyEntityType.BROKER}
                fieldKey="brokerName"
                refreshTreatyData={refreshTreatyData}
              />
            );
          })()}
    </CollapsibleSection>
  );
};
